import { tateConfig, yokoConfig } from './sheet.config'

export const S5_CW2403_TestA_2111123 = {
  FRONT: {
    EXAM_GROUP_KEY: '02523003111',
    QR_INFO: {
      checkDigit: 5318,
      correctSize: tateConfig.correctedSize,
      correctMarkers: tateConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: tateConfig.correctedRotateQrPos,
      numCheckPosition: {
        ...tateConfig.correctedNumCheckArea,
        l: tateConfig.correctedNumCheckArea.l - 2
      },
      clipScale: 0.8,
      isHorizontal: false
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02523003122',
    QR_INFO: {
      checkDigit: 5327,
      correctSize: yokoConfig.correctedSize,
      correctMarkers: yokoConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: yokoConfig.correctedRotateQrPos,
      numCheckPosition: yokoConfig.correctedNumCheckArea,
      clipScale: 1.0,
      isHorizontal: true
    }
  }
} as const
